module.exports = __webpack_public_path__ + "img/zuse.d4ddf2db.svg";